import { useEffect } from 'react'
import { Spin, Steps } from 'antd'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { slices } from 'store/slices'
import { questionBankService } from 'api/administration/questionBank'
import { createInitialQuestionBankData } from 'store/slices/initialData'
import Questions from './questions'
import Configuration from './configuration'
import { Wrapper } from './styled'

const { Step } = Steps

interface IProps {
  evaluationId?: number | null
}

const Stages = ({ evaluationId }: IProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix = 'administration.blocks.type.questionBankV2.stages'
  const stage = useAppSelector(slices.questionBank.stage)
  const loading = useAppSelector(slices.questionBank.loading)
  const pendingPrefill = useAppSelector(slices.questionBank.pendingPrefill)

  useEffect(() => {
    dispatch(slices.questionBank.setStage(0))

    if (evaluationId) {
      dispatch(slices.questionBank.setData(createInitialQuestionBankData()))
      dispatch(slices.questionBank.setLoading(true))
      questionBankService
        .getData(evaluationId)
        .then((data) => {
          dispatch(slices.questionBank.setData(data))
        })
        .catch(() => {
          dispatch(slices.questionBank.setLoading(false))
        })
        .finally(() => {
          dispatch(slices.questionBank.setLoading(false))
        })
      return
    }

    // Evaluación nueva: si la IA dejó un preview para volcar, lo cargamos una
    // sola vez; si no, partimos del estado inicial vacío.
    if (pendingPrefill) {
      dispatch(slices.questionBank.setData(pendingPrefill))
      dispatch(slices.questionBank.clearPrefill())
    } else {
      dispatch(slices.questionBank.setData(createInitialQuestionBankData()))
    }
    // pendingPrefill se omite a propósito: sólo aplica al montar el editor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, evaluationId])

  return (
    <Wrapper>
      <Steps size="small" current={stage}>
        <Step
          title={t(`${translationPrefix}.questions.title`)}
          icon={stage > 0 ? <FontAwesomeIcon icon={faCheck} /> : undefined}
        />
        <Step
          title={t(`${translationPrefix}.configuration.title`)}
          icon={stage > 1 ? <FontAwesomeIcon icon={faCheck} /> : undefined}
        />
      </Steps>
      <Spin spinning={loading}>
        {stage === 0 && <Questions />}
        {stage === 1 && <Configuration />}
      </Spin>
    </Wrapper>
  )
}

export default Stages
